var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.761 17.9166H6.80446C4.24916 17.9166 2.28883 16.9936 2.84565 13.2789L3.49401 8.24457C3.83726 6.39102 5.01957 5.68164 6.05694 5.68164H14.539C15.5916 5.68164 16.7053 6.44442 17.1019 8.24457L17.7503 13.2789C18.2232 16.5741 16.3163 17.9166 13.761 17.9166Z",
    stroke: "#27AAF8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 5.49853C13.875 3.51014 12.2631 1.89823 10.2747 1.89823V1.89823C9.31724 1.89417 8.39756 2.27169 7.71907 2.94732C7.04058 3.62295 6.65917 4.54102 6.65918 5.49853H6.65918",
    stroke: "#27AAF8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7466 9.25151H12.7085",
    stroke: "#27AAF8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88727 9.25151H7.84914",
    stroke: "#27AAF8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.b2724f6b66779b02ba80782cfe24a3c4.svg";
export { ForwardRef as ReactComponent };